export enum RESULTATS_EXAMEN_CCAP {
	SCO = "SCO",
	SCU = "SCU",
	ELIMINATION = "ELIMINATION"
}